import { render } from "./CreateIntermediary.vue?vue&type=template&id=fd0c35d0"
import script from "./CreateIntermediary.vue?vue&type=script&lang=js"
export * from "./CreateIntermediary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__